<template>
    <div class="top-performers-area">
        <div class="container-fluid">
            <div class="top-performers-content-wrap card-box-style rounded rounded-30">
                <div class="row align-items-center">
                    <div class="col-lg-3">
                        <div class="top-performers-content">
                            <h3>Top Performers</h3>
                            <p>Lorem ipsum dolor sit amet, consete tur sadipscing elitr, sed diam.</p>
                            <ul>
                                <li class="single-performers border-style-4fcb8d">
                                    <span class="title">New Task</span>
                                    <h4>304+</h4>
                                </li>
                                <li class="single-performers border-style-1765fd">
                                    <span class="title">Task Completed</span>
                                    <h4>150+</h4>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-9">
                        <div class="performers-slider">
                            <carousel
                                :autoplay="5000"
                                :wrap-around="true"
                                :breakpoints="breakpoints"
                            >
                                <Slide v-for="slide in carouselItems" :key="slide.id">
                                    <div class="single-performers-card">
                                        <div class="performers-img d-flex align-items-center">
                                            <img :src="slide.image" alt="performers-1">
                                            <div>
                                                <span>{{slide.rule}} st</span>
                                                <h2>{{slide.percent}}%</h2>
                                            </div>
                                        </div>
                                        <h3>{{slide.name}}</h3>
                                        <span>{{slide.email}}</span>
                                    </div>
                                </Slide>

                                <template #addons>
                                </template>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'TopPerformers',
    components: {
        Carousel,
        Slide,
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        carouselItems: [
            {
                id: 1,
                image: require('../../../assets/images/performers/performers-1.jpg'),
                rule: '1',
                percent: '90',
                name: 'Anderson Coopers',
                email: '@coopers',
            },
            {
                id: 2,
                image: require('../../../assets/images/performers/performers-2.jpg'),
                rule: '2',
                percent: '85',
                name: 'Alex Dew',
                email: '@alexdew',
            },
            {
                id: 3,
                image: require('../../../assets/images/performers/performers-3.jpg'),
                rule: '3',
                percent: '80',
                name: 'Kilvas Smith',
                email: '@kilvasmith',
            },
            {
                id: 4,
                image: require('../../../assets/images/performers/performers-4.jpg'),
                rule: '4',
                percent: '78',
                name: 'Zeck Smith',
                email: '@zecksmith',
            },
            {
                id: 5,
                image: require('../../../assets/images/performers/performers-5.jpg'),
                rule: '5',
                percent: '75',
                name: 'Anne Mari',
                email: '@annemari',
            },
            {
                id: 6,
                image: require('../../../assets/images/performers/performers-6.jpg'),
                rule: '6',
                percent: '70',
                name: 'Juhon Smith',
                email: '@juhonsmith',
            },
        ],
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
			},
            375: {
                itemsToShow: 2,
                snapAlign: 'center',
            },
            576: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            1320: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1400: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1700: {
                itemsToShow: 5,
                snapAlign: 'center',
            },
        },
    }),
})
</script>

<style lang="scss">
.top-performers-content-wrap {
	margin-bottom: 24px;
}
.top-performers-content {
	max-width: 300px;
	h3 {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 15px;
	}
	p {
		font-size: 14px;
		margin-bottom: 40px;
	}
	ul {
		padding-left: 0;
		margin-bottom: 0;
		list-style-type: none;
		.single-performers {
			padding-left: 10px;
			position: relative;
			display: inline-block;
			margin-right: 30px;
			&:last-child {
				margin-right: 0;
			}
			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 2px;
				height: 100%;
				background-color: #1765fd;
				border-radius: 30px;
			}
			.title {
				font-size: 13px;
				font-weight: 500;
				letter-spacing: -0.26px;
				display: block;
				margin-bottom: 4px;
			}
			h4 {
				font-size: 24px;
				margin-bottom: 0;
			}
			&.border-style-4fcb8d {
				&::before {
					background-color: #4fcb8d;
				}
			}
			&.border-style-1765fd {
				&::before {
					background-color: #1765fd;
				}
			}
		}
	}
}
.single-performers-card {
	.performers-img {
		margin-bottom: 10px;
		img {
			border-radius: 25px;
			border: 2px solid var(--white-color);
			box-shadow: var(--box-shadow);
			margin-right: 10px;
		}
		span {
			font-size: 11px;
		}
		h2 {
			font-size: 30px;
			color: #1765FD;
			margin-bottom: 0;
		}
	}
	h3 {
		font-size: 14px;
		margin-bottom: 0;
	}
	span {
		font-size: 12px;
	}
}
.performers-slider {
	.carousel {
        text-align: left;
		.carousel__slide {
			img {
				width: 75px;
				height: 75px;
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .top-performers-content {
        ul {
            margin-bottom: 30px;
        }
        p {
            margin-bottom: 30px;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .top-performers-content {
        ul {
            margin-bottom: 30px;
        }
        p {
            margin-bottom: 30px;
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .top-performers-content {
        ul {
            .single-performers {
                margin-right: 15px;
            }
        }
    }
}

/* Min width 1200px to Max width 1320px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .top-performers-content {
        ul {
            .single-performers {
                margin-right: 10px;
                margin-bottom: 0;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .top-performers-content {
        ul {
            .single-performers {
                margin-right: 15px;
            }
        }
    }
}
</style>